module.exports = __webpack_public_path__ + "assets/img/main-logo-baoding.ebb6a303.png";